export default __webpack_public_path__ + "static/media/homeDefault.ed8a0cbb.svg";